import React from 'react';
import { StyledFeaturedContainer, StyledRoot, styles } from './CategoryFeaturesSection.styles';
import { useLineageTitles } from '../../hooks/useLineageTitles';
import { Breadcrumbs } from '../Breadcrumbs';
import type { PagesForTelemetry } from '../../Catalog.telemetry.types';
import { SelectedCategoryText } from '../SelectedCategoryText';
import { useCategoryFeaturesSection } from './CategoryFeaturesSection.controller';
import ExplodedCategory from '../../routes/CatalogProductsIndex/components/ExplodedCategory';
import { Box } from '@withjoy/joykit';
import { RefinementPanelTopBarToggle } from '../RefinementPanelToggle';
import { useProductGridSortBy } from '../ProductGrid/ProductGrid.controller';
import type { ProductCatalogSearchQueryOrderBy } from '@graphql/generated';
import { MarketingText } from '@shared/utils/fonts/components';
import CatalogCarousel from '../Carousel/CatalogCarousel/CatalogCarousel';

export type CategoryFeaturesSectionProps = {
  isMobile: boolean;
  telemetryPageValue: PagesForTelemetry;
  showcaseExploreAllRef?: React.RefObject<HTMLDivElement>;
  sortBy?: ProductCatalogSearchQueryOrderBy;
  placement: 'top' | 'bottom';
};

const CategoryFeaturesSection = (props: CategoryFeaturesSectionProps) => {
  const { isMobile, telemetryPageValue, sortBy } = props;
  const lineageTitles = useLineageTitles();
  const { handleSortBy } = useProductGridSortBy();
  const { featuredCategoriesList, selectedCategory, showTopBarEndElement, handleBrowseCategoryClick } = useCategoryFeaturesSection(props);

  return (
    <StyledRoot __css={styles.root}>
      {!!lineageTitles.length && (
        <>
          <Box
            __css={{
              paddingX: 6,
              paddingBottom: { _: 4, md: 0 },
              paddingTop: { _: 4, md: 0 },
              width: '100%',
            }}
          >
            {!selectedCategory?.isPopularStoreCategory && (
              <Breadcrumbs
                defaultAlign="center"
                isMobile={isMobile}
                categoryId={selectedCategory?.id}
                hideLastBreadcrumb={false}
                telemetryPageValue={telemetryPageValue}
                endElement={
                  <RefinementPanelTopBarToggle
                    isMobileOrTablet={false}
                    sortBy={sortBy}
                    handleOnSortChange={handleSortBy}
                  />
                }
                showEndElement={showTopBarEndElement}
              />
            )}
          </Box>
          <SelectedCategoryText
            disableMarginBottom
            isDepartment={true}
          />
          {selectedCategory?.isPopularStoreCategory && (
            <Box marginBottom={5}>
              <MarketingText
                as="h1"
                typeVariant="body3"
                textAlign={'center'}
              >
                {selectedCategory?.heroText}
              </MarketingText>
            </Box>
          )}
        </>
      )}
      <CatalogCarousel
        isMobile={isMobile}
        telemetryPageValue={telemetryPageValue}
        sortBy={sortBy}
        placement="top"
      />
      <StyledFeaturedContainer __css={styles.featuredContainer}>
        {!!featuredCategoriesList.length && selectedCategory && (
          <ExplodedCategory
            id={selectedCategory.id}
            subcategories={featuredCategoriesList}
            onBrowseCategoryClick={handleBrowseCategoryClick}
          />
        )}
      </StyledFeaturedContainer>
    </StyledRoot>
  );
};

export { CategoryFeaturesSection };
